import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=0db3c03f&"
import script from "./proxy.vue?vue&type=script&lang=ts&"
export * from "./proxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports